import { render, staticRenderFns } from "./branchButton.vue?vue&type=template&id=275a2cc5&scoped=true&"
import script from "./branchButton.vue?vue&type=script&lang=js&"
export * from "./branchButton.vue?vue&type=script&lang=js&"
import style0 from "./branchButton.vue?vue&type=style&index=0&id=275a2cc5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275a2cc5",
  null
  
)

export default component.exports